import axios from 'axios'

const API_BASE_URL = process.env.REACT_APP_API_URL || '/api'

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
})

// Request interceptor to add auth token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

// Response interceptor for error handling
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token')
      localStorage.removeItem('sessionToken')
      window.location.href = '/signin'
    }
    return Promise.reject(error)
  }
)

export const mediaAPI = {
  getAllMedia: () => {
    console.log('MediaAPI: Get all media request')
    return api.get('/api/media')
  },

  getMediaById: (id) => {
    console.log('MediaAPI: Get media by ID request:', id)
    return api.get(`/api/media/${id}`)
  },

  uploadMedia: (formData) => {
    console.log('MediaAPI: Upload media request with formData:', formData)
    return api.post('/api/media', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
  },

  uploadProfilePicture: (formData) => {
    return api.post('/api/media', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        'X-Upload-Purpose': 'profile-picture',
      },
    })
  },

  uploadBusinessLogo: (formData) => {
    return api.post('/api/media', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        'X-Upload-Purpose': 'business-logo',
      },
    })
  },
}

export default mediaAPI

